import { ThemeIcon } from "@mantine/core";
import { IconCircleArrowLeftFilled } from "@tabler/icons-react";
import ButtonVariants from "../ButtonVariants";

interface IBackRoundedProps {
  href: string;
  label?: string;
}

const BackRounded: React.FC<IBackRoundedProps> = ({ href, label }) => {
  return (
    <ButtonVariants.Gradient
      className="hover-scale w-full max-w-sm rounded-md px-10"
      href={href}
      label={
        <>
          <ThemeIcon className="mr-2" size={20} variant="transparent">
            <IconCircleArrowLeftFilled />
          </ThemeIcon>
          {label}
        </>
      }
    />
  );
};

export default BackRounded;
